/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from "react";
import { ColorModeContextType } from ".";
import { IConfirmedReport } from '../models/reportConfirm';

export const SidebarContext = createContext({
    menuTitle: '', setMenuTitle: (_mnuTitle: string) => {}, 
    sideBarWidth: 0, setSideBarWidth: (_sideBarWidth: number) => {}, 
    sideBarTitleHeight: 0, setSideBarTitleHeight: (_sideBarTitleHeight: number) => {}
});

export const TemplateDirectionContext = createContext({
    rtl: true, setRtl: (_rtl: boolean) => {}
});

export const ColorModeContext = createContext<ColorModeContextType | null>(null);

export const ReportsConfirmedContext = createContext({
    confirmedReports: [{
        type: 0,
        user_c: false,
        pm_c: false,
        userconfirmshamsidate: '',
        pmconfirmshamsidate: '',
        userconfirmer: '',
    }], 
    setConfirmedReports: (_confirmedReports: IConfirmedReport[]) => {},
});

